import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

const COIN_IMAGES = {
  0: '/images/coin/bronze.png',
  1: '/images/coin/silver.png',
  2: '/images/coin/gold.png',
};

const GIFT_IMAGES = {
  0: '/images/gift/01.png',
  1: '/images/gift/02.png',
  2: '/images/gift/03.png',
  3: '/images/gift/04.png',
  4: '/images/gift/05.png',
  5: '/images/gift/06.png',
  6: '/images/gift/07.png',
  7: '/images/gift/08.png',
  8: '/images/gift/09.png',
};

const OPTION_IMAGES = brandIsPh ? GIFT_IMAGES : COIN_IMAGES;

const isBonusActive = (bonus) =>
  bonus?.state === 'available' || bonus?.state === 'active';

export { OPTION_IMAGES, isBonusActive };
